<template>
  <v-autocomplete
      :items="items"
      no-data-text="Žiadne výsledky"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:append-outer
    >
      <slot
          name="action"
          :init="init"
      />

      &nbsp;

      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click.prevent.stop="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
  export default {
    name: 'Suggest',
    props: [
      'itemsKey',
      'fetchData'
    ],
    emits: [
      'onSuccess',
      'onFail'
    ],
    data() {
      return {
        loading: false,
        total: 0,
        items: []
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.initData()
      },
      initData() {
        this.prepareData()
      },
      prepareData() {
        this.loading = true

        this.fetchData()
          .then((response) => {
            this.total = response.data.data.total

            this.items = response.data.data[this.itemsKey]

            this.$emit('onSuccess', response)
          })
          .catch((error) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: error.response.data.message
            })

            this.$emit('onFail', error.response)
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
